import { render, staticRenderFns } from "./TicketActions.vue?vue&type=template&id=10deef6b&scoped=true"
import script from "./TicketActions.vue?vue&type=script&lang=ts"
export * from "./TicketActions.vue?vue&type=script&lang=ts"
import style0 from "./TicketActions.vue?vue&type=style&index=0&id=10deef6b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10deef6b",
  null
  
)

export default component.exports